import { useState } from "react";

const VOICE_HOST = import.meta.env.VITE_VOICE_BACKEND_URL || "https://mudcarp.pl";
const OVERLAY_URL = `${VOICE_HOST}/overlay`;

export function AdminOverlay() {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(OVERLAY_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  }

  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display font-bold text-3xl">OBS overlay</h1>
        <p className="text-sm text-carp-ink/70">
          Warstwa do dodania w OBS Studio jako <b>Browser source</b>. Pokazuje
          każdy donejt na żywo: nick, kwotę, treść wiadomości i odpowiedź MudCarpa.
        </p>
      </header>

      <section className="brut bg-carp-paper p-5">
        <h2 className="font-display font-bold text-lg mb-3">URL overlay</h2>
        <div className="flex flex-wrap items-center gap-2">
          <input
            readOnly
            value={OVERLAY_URL}
            className="input-brut flex-1 font-mono text-sm"
            onFocus={(e) => e.currentTarget.select()}
          />
          <button type="button" className="btn-primary" onClick={copy}>
            {copied ? "Skopiowane ✓" : "Kopiuj"}
          </button>
        </div>
        <p className="text-xs text-carp-ink/60 mt-2 font-mono">
          Zalecane wymiary OBS: 1920×1080 (lub Twoja rozdzielczość streamu).
          Tło layeru jest przezroczyste — overlay ląduje na lewym dole.
        </p>
      </section>

      <section className="brut bg-carp-paper p-5">
        <h2 className="font-display font-bold text-lg mb-3">Jak dodać w OBS</h2>
        <ol className="list-decimal pl-6 space-y-1 text-sm leading-relaxed">
          <li>OBS Studio → Sources → <b>+</b> → <b>Browser</b></li>
          <li>
            URL: <code className="font-mono bg-carp-ink/10 px-1">{OVERLAY_URL}</code>
          </li>
          <li>Width 1920 · Height 1080 · FPS 30 (lub jak masz scenę)</li>
          <li>
            ✅ <b>Shutdown source when not visible</b> — opcjonalnie (oszczędza CPU)
          </li>
          <li>
            ✅ <b>Refresh browser when scene becomes active</b> — odświeża stan SSE
          </li>
        </ol>
      </section>

      <section className="brut bg-carp-paper p-2">
        <p className="text-xs font-mono uppercase text-carp-ink/60 px-3 pt-2 pb-1">
          Podgląd na żywo (ten sam SSE feed, którego słucha OBS)
        </p>
        <iframe
          src={OVERLAY_URL}
          title="OBS overlay preview"
          className="w-full h-[420px] border-[3px] border-carp-ink bg-[#1f1d20]"
          style={{ background: "#1f1d20" }}
        />
      </section>

      <section className="brut bg-carp-yellow p-4">
        <h3 className="font-display font-bold text-sm uppercase tracking-wide mb-2">
          Co overlay pokazuje
        </h3>
        <ul className="text-sm list-disc pl-5 space-y-0.5">
          <li>Faza 1 — czytana wiadomość donatora (nick + kwota + treść)</li>
          <li>Faza 2 — live caption z odpowiedzią MudCarpa (per-token streaming)</li>
          <li>Po zakończeniu odpowiedzi overlay znika po ~6 sekundach</li>
          <li>
            Stan przeżywa F5 / restart OBS — przy reconnect SSE wysyła aktualny
            snapshot
          </li>
        </ul>
      </section>
    </div>
  );
}
